import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyCowSales, getDairyCowSalesAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_COWS_SOLD } from "consts";

export const useGetFootprintingDairyCowSalesByPrimaryDataId = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_COWS_SOLD, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getDairyCowSalesAdmin(primaryDataId) : getDairyCowSales(primaryDataId)),
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
